import {TemplateType} from "@generated"
import {StateLabel} from "@platform/models/state-labels/state-label"

export const TemplateTypeLabels: Map<TemplateType, StateLabel<TemplateType>> = new Map<TemplateType, StateLabel<TemplateType>>([
    [TemplateType.Product, {state: TemplateType.Product, label: "Product", background: "#989898"}],
    [TemplateType.Scene, {state: TemplateType.Scene, label: "Scene", background: "#ffab4a"}],
    [TemplateType.Part, {state: TemplateType.Part, label: "Part", background: "#7cbcb0"}],
    [TemplateType.Picture, {state: TemplateType.Picture, label: "Picture", background: "#ff6f61"}],
    [TemplateType.System, {state: TemplateType.System, label: "System", background: "#7cbcb0"}],
])
